import Vue from 'vue'
import i18n from '@/i18n'
var numeral = require('numeral')

Vue.filter('gender', function (value) {
  const gender = parseInt(value)
  return gender ? i18n.t('gender.female') : i18n.t('gender.male')
})

Vue.filter('userRole', function (value) {
  const role = parseInt(value)
  let roles = {
    1: i18n.t('user.role.admin'),
    2: i18n.t('user.role.manager'),
    3: i18n.t('user.role.professor'),
    4: i18n.t('user.role.student')
  }
  return roles[role]
})

Vue.filter('courseName', function (course) {
  return course.code + ' - ' + course.name + ' (' + course.num_crd + 'TC)'
})

Vue.filter('formatNumber', function (value) {
  return numeral(value).format('0.0')
})

Vue.filter('importStatus', function (value) {
  if (value === 1) {
    return "<span class='text-info'><i class='el-icon-loading'></i>&nbsp;" + i18n.t('import.processing') + '</span>'
  } else if (value === 2) {
    return "<span class='text-success'><i class='el-icon-check'></i>&nbsp;" + i18n.t('import.success') + '</span>'
  } else {
    return "<span class='text-danger'><i class='el-icon-close'></i>&nbsp;" + i18n.t('import.failed') + '</span>'
  }
})

Vue.filter('formatFileName', function (str) {
  if (str === undefined) return null
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
  str = str.replace(/Đ/g, 'D')
  str = str.replace(/[^0-9a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ\s]/gi, '')
  str = str.replace(/\s+/g, ' ')
  str = str.replace(/\W+/g, ' ')
  str = str.replace(/\s/g, '-')
  str.trim()
  return str
})



// WEBPACK FOOTER //
// ./src/filters/custom.js